import { SupabaseProvider } from './supabase.provider.js'
import { AppwriteProvider } from './appwrite.provider.js'
import { PocketBaseProvider } from './pocketbase.provider.js'
import { config } from '../config.js'

// 获取当前配置的持久化提供商
const PERSISTENCE_PROVIDER = config.PERSISTENCE_PROVIDER || 'supabase'

let providerInstance = null

/**
 * 获取或创建持久化提供商实例
 * @returns {PersistenceProvider}
 */
export function getProvider() {
  if (!providerInstance) {
    switch (PERSISTENCE_PROVIDER.toLowerCase()) {
      case 'appwrite':
        providerInstance = new AppwriteProvider()
        break
      case 'pocketbase':
        providerInstance = new PocketBaseProvider()
        break
      case 'supabase':
      default:
        providerInstance = new SupabaseProvider()
        break
    }
  }
  return providerInstance
}

/**
 * 重置提供商实例（主要用于测试）
 */
export function resetProvider() {
  providerInstance = null
}

/**
 * 获取当前提供商名称
 * @returns {string}
 */
export function getProviderName() {
  return PERSISTENCE_PROVIDER
}

// 创建默认实例并导出
const provider = getProvider()

// 导出认证和数据库操作的便利函数
export const auth = {
  signUp: (email, password, metadata) => provider.signUp(email, password, metadata),
  signIn: (email, password) => provider.signIn(email, password),
  signOut: () => provider.signOut(),
  getSession: () => provider.getSession(),
  getUser: () => provider.getUser(),
  onAuthStateChange: (callback) => provider.onAuthStateChange(callback),
  ensureUserProfile: (user, username) => provider.ensureUserProfile(user, username)
}

export const db = {
  from: (collection) => provider.from(collection),
  getDatabase: () => provider.getDatabase()
}

// 导出数据库表名常量
export const DB_TABLES = {
  USERS: 'users',
  TODOS: 'todos'
}

// 导出认证错误常量
export const AUTH_ERRORS = {
  INVALID_CREDENTIALS: 'Invalid login credentials',
  EMAIL_NOT_CONFIRMED: 'Email not confirmed',
  USER_NOT_FOUND: 'User not found',
  NETWORK_ERROR: 'Network error'
}

export default provider
